import React from 'react';  // eslint-disable-line

const AddPlus = (props) => {
    return (
        <svg width={props.size || '14px'} height={props.size || '14px'} viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="custom-content-banner-image-9-v2" transform="translate(-590.000000, -544.000000)">
                    <g id="Group" transform="translate(585.000000, 539.000000)">
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                        <path d="M18.4166667,10.8333333 L13.1666667,10.8333333 L13.1666667,5.58333333 C13.1666667,5.26104167 12.905625,5 12.5833333,5 L11.4166667,5 C11.094375,5 10.8333333,5.26104167 10.8333333,5.58333333 L10.8333333,10.8333333 L5.58333333,10.8333333 C5.26104167,10.8333333 5,11.094375 5,11.4166667 L5,12.5833333 C5,12.905625 5.26104167,13.1666667 5.58333333,13.1666667 L10.8333333,13.1666667 L10.8333333,18.4166667 C10.8333333,18.7389583 11.094375,19 11.4166667,19 L12.5833333,19 C12.905625,19 13.1666667,18.7389583 13.1666667,18.4166667 L13.1666667,13.1666667 L18.4166667,13.1666667 C18.7389583,13.1666667 19,12.905625 19,12.5833333 L19,11.4166667 C19,11.094375 18.7389583,10.8333333 18.4166667,10.8333333 Z" id="Path" fill={props.color || '#616B7D'} />
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default AddPlus;
